import { ServiceSchedule, WeeklyScheduleRules } from "./types";

export const TEXTS = {
  SCHEDULES: {
    HEADER: "Schedules",
    SNAPSHOT_SECTION: "VCS Snapshot",
    VIEW_FULL_CALENDAR: "View full calendar",
  },
  SNAPSHOT_SCHEDULE: {
    CREATED_AT: "Latest created at",
    PENDING: "...pending",
    NEXT_SNAPSHOT: "Next snapshot",
  },
  SCHEDULES_INFO: {
    DESCRIPTION: `Monitor snapshot creation and service pull windows by release stage.
        Configuration edits are captured into versioned VCS snapshots and distributed to downstream services during scheduled publishing cycles.`,
    MAINTENENCE_NOTICE:
      "Note: Scheduled runs operate within approved regional maintenance windows and automatically pause during active change blackouts.",
  },
  SCHEDULES_TABLE: {
    RS_COL: "Release stage",
    LAST_PULL_COL: "Last pull",
    NEXT_PULL_COL: "Next pull (est.)",
    JOB_STATUS: "Check job status",
    PENDING: "Schedule pending",
  },
  SERVICE_TITLES: {
    APS_JOB_SCHEDULE: "APS job schedule",
    PCD_JOB_SCHEDULE: "PCD job schedule",
  },
};

export const APS_LINKS = {
  FULL_CALENDAR:
    "https://xperi.atlassian.net/wiki/spaces/AppProxy/pages/854196250/APS+Federated+Services+Cron+Schedule+and+Blackout+Window+Management",
  JOB_STATUS: {
    RS1: "https://teams.cloud.microsoft/l/channel/19%3Ad5755e5e0bf84ba89a1c736a2458e7b8%40thread.tacv2/aps-csp-promotion-notifications-rs1",
    RS2_RS3:
      "https://teams.cloud.microsoft/l/channel/19%3A07b595212abd40e6ac1ff9eebf62dda3%40thread.tacv2/aps-csp-promotion-notifications-rs2-rs3",
  },
} as const;

export const PCD_LINKS = {
  FULL_CALENDAR:
    "https://xperi.atlassian.net/wiki/spaces/COP/pages/1109786720/Schedule+of+TVCS+Jobs",
  JOB_STATUS: {
    RS1: "https://teams.microsoft.com/l/channel/19%3A48883de6e2694cc3aad593c0d9f07d73%40thread.tacv2/co-tvcs-staging",
    RS2_3:
      "https://teams.microsoft.com/l/channel/19%3Abeb7331e4bc64b09bc132e4f4fcdc4e5%40thread.tacv2/co-tvcs-prod",
  },
};

/* eslint-disable no-magic-numbers */
const EVERY_DAY = [0, 1, 2, 3, 4, 5, 6];

const daily = (...hours: number[]): WeeklyScheduleRules => [
  { days: EVERY_DAY, hours },
];
const everyTwoHoursFrom = (start: number) =>
  daily(...Array.from({ length: 12 }, (_, i) => (start + i * 2) % 24));

// All hours are UTC.
const RS3_EU_SCHEDULE: WeeklyScheduleRules = [
  { days: [0, 1, 2, 3, 4], hours: [23] },
]; // Sun–Thu
const RS3_US_SCHEDULE: WeeklyScheduleRules = [
  { days: [1, 2, 3, 4, 5], hours: [6] },
]; // Mon–Fri

export const SERVICES: ServiceSchedule[] = [
  {
    title: TEXTS.SERVICE_TITLES.APS_JOB_SCHEDULE,
    stageSchedules: [
      {
        stage: "RS1",
        schedule: everyTwoHoursFrom(1),
        jobStatusUrl: APS_LINKS.JOB_STATUS.RS1,
      },
      {
        stage: "RS2",
        schedule: [...RS3_EU_SCHEDULE, ...RS3_US_SCHEDULE],
        jobStatusUrl: APS_LINKS.JOB_STATUS.RS2_RS3,
      },
      {
        stage: "RS3-EU",
        schedule: RS3_EU_SCHEDULE,
        jobStatusUrl: APS_LINKS.JOB_STATUS.RS2_RS3,
      },
      {
        stage: "RS3-US",
        schedule: RS3_US_SCHEDULE,
        jobStatusUrl: APS_LINKS.JOB_STATUS.RS2_RS3,
      },
    ],
    calendarUrl: APS_LINKS.FULL_CALENDAR,
  },
  {
    title: TEXTS.SERVICE_TITLES.PCD_JOB_SCHEDULE,
    stageSchedules: [
      {
        stage: "RS1",
        schedule: everyTwoHoursFrom(5),
        jobStatusUrl: PCD_LINKS.JOB_STATUS.RS1,
      },
      {
        stage: "RS2",
        schedule: daily(6),
        jobStatusUrl: PCD_LINKS.JOB_STATUS.RS2_3,
      },
      {
        stage: "RS2-US",
        schedule: daily(23),
        jobStatusUrl: PCD_LINKS.JOB_STATUS.RS2_3,
      },
      {
        stage: "RS3",
        schedule: daily(6),
        jobStatusUrl: PCD_LINKS.JOB_STATUS.RS2_3,
      },
      {
        stage: "RS3-US",
        schedule: daily(23),
        jobStatusUrl: PCD_LINKS.JOB_STATUS.RS2_3,
      },
    ],
    calendarUrl: PCD_LINKS.FULL_CALENDAR,
  },
];

export const VCS_SNAPSHOT_SCHEDULE: WeeklyScheduleRules = [
  {
    days: EVERY_DAY,
    hours: [4, 12, 14, 16, 18, 20, 21],
  },
];
